import React, { useState, useEffect,  useContext , useRef } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import LandingNav from "../Landing_Nav";
import group9 from "../../../images/dashakasoft.webp";
import google from "../../../images/LandingPageImage/google.png";
import { ToastContainer } from "react-toastify";
import ThreeCardsSection from "./ThreeCardsSection";
import SecondScroll from "./SecondScroll";
import FifthSection from "./FifthSection";
import ForthSection from "./ForthSection";
import LandingFooter from "../Landing_Footer";
import FaQ from "./FaQ";
import Pricing from "./PricingSection";
import CtaSection from "./CtaSection";
import ExternalChatBot from "./ChatBot";
import MyContext from "../../../MyContext";
import GoogleOneTap from "../../GoogleOneTapnew";
import { useLocation } from "react-router-dom";
import BuiltForBusiness from "./Bussinescard";
import AivoiceSection from "./Aisection";
import { FaUserAlt } from "react-icons/fa";
import { RiVoiceprintFill } from "react-icons/ri";
const slideData = {
  id: 1,
  subtitle:
    "Conversational AI combines AI Voice Assistants with WhatsApp Automation to answer calls, respond instantly, and manage high-volume conversations — improving efficiency while reducing manual support effort.",
  image: group9,
  ctaPrimary: "Start Free Trial",
  ctaSecondary: "Start Free Trial"
};

const AutoScrollHero = () => {
  const [isVisible, setIsVisible] = useState(false);
    const hasAutoOpened = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
const { openFreeTrialModal } = useContext(MyContext);

  useEffect(() => {
    // small stagger so animations appear after mount
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("accessToken");

    if (!isLoggedIn && !hasAutoOpened.current) {
      hasAutoOpened.current = true;

      const timer = setTimeout(() => {
        openFreeTrialModal();
      }, 0); 

      return () => clearTimeout(timer);
    }
  }, [openFreeTrialModal]);

  useEffect(() => {
  const pageKey = location.pathname;
  const storageKey = `freeTrialClosed_${pageKey}`;

  if (!sessionStorage.getItem(storageKey)) {
    openFreeTrialModal(pageKey);
  }

  return () => {
    sessionStorage.removeItem(storageKey);
  };
}, [location.pathname]);


  const slide = slideData;

  return (
    <>
  

      <style>{`
        :root {
          --hero-bg-1: #280410;
          --hero-bg-2: #9e104c;
          --accent: #f11960;
          --accent-light: #ffb3d1;
          --max-width: 1600px;

          /* THESE MUST MATCH LandingNav .ln-container paddings */
          --nav-padding-desktop: 5rem;   /* desktop padding in LandingNav */
          --nav-padding-xl: 4rem;        /* <=1400px */
          --nav-padding-lg: 3rem;        /* <=1200px */
          --nav-padding-md: 2rem;        /* <=992px */
          --nav-padding-sm: 1.25rem;     /* <=768px */
        }

        .hero-section {
          width: 100%;
          background: linear-gradient(135deg, var(--hero-bg-1), var(--hero-bg-2));
          padding: 4rem 0;
          position: relative;
          overflow: hidden;
          min-height: 500px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        /* hero-container uses same left padding as navbar so text aligns under logo */
        .hero-container {
          width: 100%;
          max-width: var(--max-width);
          margin: 0 auto;
          display: flex;
          padding-left: var(--nav-padding-desktop);
          padding-right: var(--nav-padding-desktop);
          align-items: center;
          justify-content: space-between;
          gap: 2rem;
        }

        /* left column */
        .hero-left {
          flex: 1 1 48%;
          max-width: 720px;
          z-index: 3;
          text-align: left;
        }

        .hero-title {
          font-size: 2.4rem;
          font-weight: 700;
          line-height: 1.12;
          color: #ffffff;
          margin: 0;
          opacity: 0;
          transform: translateX(-110%);
          transition: opacity 900ms cubic-bezier(.2,.9,.2,1), transform 900ms cubic-bezier(.2,.9,.2,1);
        }

        .hero-title.visible {
          opacity: 1;
          transform: translateX(0);
        }

        .pink-text {
          color: var(--accent);
        }

        .hero-sub {
          margin-top: 1rem;
          font-size: 1.05rem;
          color: #ffffff;
          line-height: 1.5;
          max-width: 45ch;
          opacity: 0;
          transform: translateX(-110%);
          transition: opacity 900ms cubic-bezier(.2,.9,.2,1) 150ms, transform 900ms cubic-bezier(.2,.9,.2,1) 150ms;
        }

        .hero-sub.visible {
          opacity: 1;
          transform: translateX(0);
        }

        .hero-ctas {
          margin-top: 1.5rem;
          display: flex;
          gap: 0.9rem;
          flex-wrap: wrap;
          opacity: 0;
          transform: translateX(-110%);
          transition: opacity 900ms cubic-bezier(.2,.9,.2,1) 250ms, transform 900ms cubic-bezier(.2,.9,.2,1) 250ms;
        }

        .hero-ctas.visible {
          opacity: 1;
          transform: translateX(0);
        }

        .btn-primary {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 28px;
          padding: 0.6rem 1.2rem;
          font-weight: 700;
          cursor: pointer;
          border: none;
          outline: none;
          white-space: nowrap;
          background: var(--accent);
          color: #fff;
          transition: background 200ms ease, color 200ms ease, transform 150ms ease;
        }

        .btn-primary:hover,
        .btn-primary:focus {
          background: var(--accent-light);
          color: var(--accent);
          transform: translateY(-2px);
        }

         .btn-secondary {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 28px;
          padding: 0.6rem 1.2rem;
          font-weight: 700;
          cursor: pointer;
          border: none;
          outline: none;
          white-space: nowrap;
          background: var(--accent);
          color: #fff;
          transition: background 200ms ease, color 200ms ease, transform 150ms ease;
        }

        .btn-secondary:hover,
        .btn-secondary:focus {
          background: var(--accent-light);
          color: var(--accent);
          transform: translateY(-2px);
        }

        /* right column - image */
        .hero-right {
          flex: 1 1 48%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          z-index: 1;
          max-width: 720px;
          height: 520px;
          padding-right: calc(var(--nav-padding-desktop) * 0.6); /* slight offset to match visual balance with nav */
        }

        .hero-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
          opacity: 0;
          transform: translateX(80%);
          transition: opacity 900ms cubic-bezier(.2,.9,.2,1) 120ms, transform 900ms cubic-bezier(.2,.9,.2,1) 120ms;
          pointer-events: none;
          user-select: none;
          max-width: 100%;
          max-height: 100%;
        }

        .hero-image.visible {
          opacity: 1;
          transform: translateX(0);
        }

        /* Small aesthetic vignette/overlay to make text pop */
        .hero-overlay {
          position: absolute;
          inset: 0;
          pointer-events: none;
          background: radial-gradient(800px 400px at 10% 30%, rgba(255,255,255,0.03), transparent 10%),
                      radial-gradient(600px 300px at 90% 70%, rgba(0,0,0,0.18), transparent 15%);
          z-index: 2;
        }

        /* Responsive paddings that match LandingNav breakpoints */
        @media (max-width: 1400px) {
          .hero-container {
            padding-left: var(--nav-padding-xl);
            padding-right: var(--nav-padding-xl);
          }
        }

        @media (max-width: 1200px) {
          .hero-container {
            padding-left: var(--nav-padding-lg);
            padding-right: var(--nav-padding-lg);
          }
        }

        @media (max-width: 992px) {
          .hero-container {
            padding-left: var(--nav-padding-md);
            padding-right: var(--nav-padding-md);
            flex-direction: column;
            align-items: center;
            text-align: center;
          }

          .hero-left {
            max-width: 90%;
            margin: 0 auto;
          }

          .hero-title {
            text-align: center;
          }

          .hero-sub {
            text-align: center;
            max-width: 38ch;
            margin-left: auto;
            margin-right: auto;
          }

          .hero-ctas {
            justify-content: center;
            margin-bottom: 1.5rem;
          }

          .hero-right {
            height: 360px;
            padding-right: 0;
            margin-top: 0.5rem;
          }
        }

        @media (max-width: 768px) {
          .hero-container {
            padding-left: var(--nav-padding-sm);
            padding-right: var(--nav-padding-sm);
          }
          .hero-title { font-size: 1.6rem; }
          .hero-sub { font-size: 1rem; }
          .hero-right { height: 300px; }
        }
.chat-bubble {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.7rem 1.2rem;
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 600;
  white-space: nowrap;
  backdrop-filter: blur(6px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.25);
  animation-duration: 10s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  z-index: 4;
}

.chat-bubble .icon {
  font-size: 1rem;
}

/* USER bubble */
.chat-bubble.user {
  background: linear-gradient(135deg, #f11960, #9e104c);
  color: #fff;
  top: 32%;
  left: -40%;
  animation-name: slideUser;
}

/* BOT bubble */
.chat-bubble.bot {
  background: rgba(255,255,255,0.95);
  color: #9e104c;
  top: 52%;
  left: -50%;
  animation-name: slideBot;
  animation-delay: 2s;
}

/* Floating animation for bubbles */
@keyframes floatBubble {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); } /* move up 6px */
}

.chat-bubble.user,
.chat-bubble.bot {
  position: absolute;
  animation: floatBubble 2s ease-in-out infinite;
}


.chat-bubble.user { top: 69%; left: 30%; transform: translateX(-50%); }
.chat-bubble.bot  {   top: 81%;
  left: 18%; transform: translateX(-50%); }
/* Hide bubbles on small screens */
@media (max-width: 768px) {
  .chat-bubble {
    display: none;
  }
}

        @media (max-width: 480px) {
          .hero-container {
            padding-left: 1.2rem;
            padding-right: 1.2rem;
          }
          .hero-left { max-width: 95%; }
          .hero-right { height: 240px; }
        }
      `}</style>

      <section
        className="hero-section"
        aria-label="AkaSoft hero section"
      >
        <div className="hero-container">
          {/* LEFT: Text */}
          <div className="hero-left">
            <h1 className={`hero-title ${isVisible ? "visible" : ""}`}>
              <span className="pink-text" style={{color:"#F11960"}}>AI voice assistants</span> & <span className="pink-text" style={{color:"#F11960"}}>WhatsApp<br/> Automation</span>
              &nbsp; for seamless customer communication
            </h1>

            <p className={`hero-sub ${isVisible ? "visible" : ""}`}>
              {slide.subtitle}
            </p>

            <div className={`hero-ctas ${isVisible ? "visible" : ""}`}>
              <button
                  className="btn btn-primary d-flex align-items-center gap-2"
                  onClick={() => navigate("/login?provider=google")}
                >
                  <span>Continue with</span>
                  <img
                    src={google}
                    alt="Google"
                    style={{ width: "28px", height: "28px" }}
                  />
                </button>

              <button onClick={openFreeTrialModal} className="btn-secondary">
                {slide.ctaPrimary}
              </button>
            </div>
          </div>

          {/* RIGHT: Image */}
          <div className="hero-right" aria-hidden="true">
            <img
              src={slide.image}
              alt="Illustration: WhatsApp automation workspace"
              className={`hero-image ${isVisible ? "visible" : ""}`}
              loading="lazy"
              draggable={false}
            />
          {/* USER bubble */}

<div className="chat-bubble user d-inline-flex align-items-center gap-1 p-2 fs-7 shadow-sm">
<FaUserAlt style={{fontSize:"2rem"}} />
I want to order a pizza near my <br/>location 
</div>
{/* BOT bubble */}
<div className="chat-bubble bot d-inline-flex align-items-center mt-3 gap-1 p-2 fs-7 shadow-sm">
<RiVoiceprintFill style={{fontSize:"2rem"}} />
  Sure! Here’s a list of nearby <br/>restaurants 
</div>

            <div className="hero-overlay" aria-hidden="true" />
          </div>
        </div>
      </section>
    </>
  );
};

const Home = ({ country, handleCountryChange }) => {
  const [pageData, setPageData] = useState(null);

 
  const handleGoogleResponse = async (response) => {
    try {
      const credential = response.credential;
      if (!credential) return;


      const base64Url = credential.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const decodedData = JSON.parse(atob(base64));

      const googleUser = {
        name: decodedData.name,
        email: decodedData.email,
        picture: decodedData.picture,
        google_id: decodedData.sub, // IMPORTANT
      };

      const [firstName, ...rest] = googleUser.name.split(" ");
      const lastName = rest.join(" ");

      const basicAuth = btoa("BUMPPY_SSO_SgLjvARJ5LbX:tGhAlPHEkx1McBnkw43vXUXs44i744jQbbjU1ODHB5SIRtSDFYaYF1yeGFJBYlZq");

      const registerResponse = await fetch(
        "https://auth.seobix.com/api/Auth/register2",
        {
          method: "POST",
          headers: {
            "Accept": "*/*",
            "Content-Type": "application/json",
            "Authorization": `Basic ${basicAuth}`,
          },
          body: JSON.stringify({
            username: googleUser.email,
            password: googleUser.google_id, // or any generated value
            firstName:googleUser.name,
            lastName:googleUser.name,
            dob: "",
            gender: "",
            country: "91",
            latitude: "",
            longitude: "",
            device: "web",
            callback: "",
            productId: "8",
            login_with: "google",
            google_id: googleUser.google_id,
            display_img:googleUser.picture,
          }),
        }
      );

      const registerData = await registerResponse.json();
      console.log("Register API:", registerData);

      // ❗ API returns 200 but status=401 in body
      if (registerData.status === "401") {
        console.warn("User already exists or unauthorized, continuing login");
      }

      // =========================
      // 2️⃣ IDENTITY / LOGIN API
      // =========================
      const identityResponse = await fetch(
        "https://auth.seobix.com/api/Auth/identityGoogle",
        {
          method: "POST",
          headers: {
            "Accept": "*/*",
            "Content-Type": "application/json-patch+json",
             "Authorization": `Basic ${basicAuth}`,
          },
          body: JSON.stringify({
            email: googleUser.email,
            latitude: null,
            longitude: null,
            device: "web",
            country: "+91",
            productId: "8",
            callback: null,
          }),
        }
      );

      const identityData = await identityResponse.json();
      console.log("Identity API:", identityData);


      localStorage.setItem("accessToken", identityData.accessToken);
      localStorage.setItem("refreshToken", identityData.refreshToken);
      localStorage.setItem("userId", identityData.userId);


      if (window.google?.accounts?.id) {
        window.google.accounts.id.cancel();
      }

      const urlParams = new URLSearchParams(window.location.search);
      const callbackUrl = urlParams.get("callback");

      if (callbackUrl && identityData?.accessToken) {
        const url = new URL(callbackUrl);

        url.searchParams.set("accessToken", identityData.accessToken);



        window.location.href = url.toString();
      }

    } catch (err) {
      console.error("Google Login Error:", err);
    }
  };
  return (
    <>
 

      <div className="d-flex justify-content-center">
        <ToastContainer />
      </div>

          
      <LandingNav country={country} handleCountryChange={handleCountryChange} />

      <AutoScrollHero />
      <BuiltForBusiness/>
      <AivoiceSection/>
      <SecondScroll />

      <ThreeCardsSection />
      <ForthSection />
      <FifthSection />
      <Pricing/>
      <FaQ />
      <CtaSection/>
      <ExternalChatBot/>
      <LandingFooter />
      <GoogleOneTap onSuccess={handleGoogleResponse} />
    </>
  );
};

export default Home;